import apiClient from "../core/config/api";

export const couponService = {
  verifyCoupon: async (
    coupon_id: string,
    user_id?: number
  ) => {
    const { data } = await apiClient.post(
      "/coupon-usage/verify",
      {
        coupon_id,
        user_id,
      }
    );

    return data;
  },
};